import $ from "jquery";
import formValidator from "./formvalidator";
import { debounce } from "./helper";

let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
});

export function scrollToTarget(elem, headerOffset) {
    var element = elem[0];
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}

export function resetFormSelect(select) {
    select.val('');
}
export function resetAndHideFormSection(section) {
    section.find('select,input,textarea').val('');
    section.slideUp(100);
}
export function setBohrlochRowActions(row) {
    const dmInput = row.find('input[data-dm]');
    const axInput = row.find('input[data-ax]');
    const ayInput = row.find('input[data-ay]');

    dmInput.on('input.setLoch', function () {
        const input = $(this);
        const bNum = input.parents('.b-row[data-bnr]').first().attr('data-bnr');
        if (input.val() > 0) {
            $(`#glas-outline .bohrloch[data-bnr="${bNum}"]`).css({ 'width': input.val() + 'px', 'height': input.val() + 'px' }).show();
        } else {
            $(`#glas-outline .bohrloch[data-bnr="${bNum}"]`).hide();
        }
        axInput.trigger('input.setPosLoch');
        ayInput.trigger('input.setPosLoch');
    });

    axInput.on('input.setPosLoch', function () {
        const input = $(this);
        const bNum = input.attr('name').split('-');

        $(`#glas-outline .bohrloch[data-bnr="${bNum[1]}"]`).css({ 'left': (parseFloat(input.val()) - parseFloat(dmInput.val()) / 2) + 'px' });
    });
    ayInput.on('input.setPosLoch', function () {
        const input = $(this);
        const bNum = input.attr('name').split('-');
        $(`#glas-outline .bohrloch[data-bnr="${bNum[1]}"]`).css({ 'top': (parseFloat(input.val()) - parseFloat(dmInput.val()) / 2) + 'px' });
    });
}

export function resetAllBohrungen() {
    $('#glas-outline .bohrloch').not('.bohrloch[data-bnr="1"]').remove();
    $('#glas-outline .bohrloch').css({ "width": 0, "height": 0, "left": 0, "top": 0 });
    $('#auswahl-bohrung .b-row').not(':first').remove();
    $('#auswahl-bohrung .b-row:first').attr('data-bnr', 1);
    $('#auswahl-bohrung .b-row:first input').val('');
    $('#auswahl-bohrung .b-row:first input').trigger('input.setLoch');
    $('#bohrungen').attr('data-bohrungen', 1);
    $('#bohrungen .b-row[data-bnr="1"] input[data-dm]').trigger('input');
    $(`.zusammenfassung [data-source="bohrungen"]`).html('');
    $('#preis').text('0,00 €');
}

export function cloneBohrlochRow(bRow) {
    const bohrungen = $('#bohrungen').attr('data-bohrungen');
    const newBnr = parseFloat(bohrungen) + 1;
    $('#bohrungen').attr('data-bohrungen', newBnr);
    const rClone = bRow.clone();
    const bClone = $(`#glas-outline .bohrloch[data-bnr="${bohrungen}"]`).clone();
    rClone.attr('data-bnr', newBnr);
    rClone.find('.bohr-nr').text(newBnr);
    rClone.find('label').each(function () {
        const lFor = $(this).attr('for').split('-');
        $(this).attr('for', lFor[0] + '-' + (newBnr));
    });
    rClone.find('input').each(function () {
        const id = $(this).attr('id').split('-');
        $(this).attr('id', id[0] + '-' + (newBnr));
        $(this).attr('name', id[0] + '-' + (newBnr));
    });
    rClone.find('button.action').removeClass('plus').addClass('minus').attr('data-action', 'minus').text('-');

    bClone.attr('data-bnr', newBnr);

    $('#auswahl-bohrung #bohrungen').first().append(rClone);
    $('#glas-outline').append(bClone);

    const newRow = $(`label[for="durchmesser-${newBnr}"]`).parents('.b-row').first();
    setBohrlochRowActions(newRow);

    newRow.find(`button.minus`).on('click.deleteBohrloch', function (e) {
        e.preventDefault();
        const btn = $(this);
        const bRow = btn.parents('.b-row').first();
        const bnr = bRow.attr('data-bnr');
        bRow.remove();
        $(`#glas-outline .bohrloch[data-bnr="${bnr}"]`).remove();
        $('#bohrungen .b-row').each(function (index, elem) {
            const newIndex = index + 1;
            $(elem).attr('data-bnr', newIndex).find('.bohr-nr').text(newIndex);
            $(elem).find('input').each(function () {
                const bName = $(this).attr('name').split('-');
                $(this).attr('name', bName[0] + '-' + newIndex);
                $(this).attr('id', bName[0] + '-' + newIndex);
            });
            $(elem).find('label').each(function () {
                const bName = $(this).attr('for').split('-');
                $(this).attr('for', bName[0] + '-' + newIndex);
            });
        });
        $('#glas-outline .bohrloch').each(function (index, elem) {
            const newIndex = index + 1;
            $(elem).attr('data-bnr', newIndex);
        });
        const bohrNr = $('#bohrungen .b-row').length;
        $('#bohrungen').attr('data-bohrungen', bohrNr);

        $('#bohrungen .b-row[data-bnr="1"] input[data-dm]').trigger('input');
        const form = $('#bohrungen').parents('form').first();
        setCalculatedPrice(form);
    });

    return newRow;
}

export function setBohrlochValues(row, { dm, ax, ay }) {
    row.find('input[data-dm]').val(parseInt(dm)).trigger('input.setLoch');
    row.find('input[data-ax]').val(parseInt(ax)).trigger('input.setPosLoch');
    row.find('input[data-ay]').val(parseInt(ay)).trigger('input.setPosLoch');
}

export function checkFormSectionValidity(section) {
    const formFieldsValidity = [];
    section.find('input,select,textarea').each(function () {
        const input = $(this);
        formFieldsValidity.push(formValidator.validateInput(input));
    });
    if (formFieldsValidity.includes(false)) {
        return false;
    } else {
        return true;
    }
}

export function clearLocalStorage(hours) {
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('setupTime');
    if (setupTime == null) {
        localStorage.setItem('setupTime', now)
    } else {
        if (now - setupTime > hours * 60 * 60 * 1000) {
            localStorage.clear()
            localStorage.setItem('setupTime', now);
        }
    }
}

export function setKonf() {
    localStorage.setItem('konf', '{"breite":600,"hoehe":600,"eckabschnitt":"","eckrundung":""}');
}

export function rdtsGetTransients() {
    const tauthKey = localStorage.getItem('tauthKey') ? localStorage.getItem('tauthKey') : null;

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'get_transients',
            'security': ajax_object.security,
            'data': tauthKey
        },
        success: function (data) {
            localStorage.setItem('tauthKey', data.bid);
        }
    });
}

export function setCalculatedPrice(form) {

    const loecher = $('#bohrungen .b-row').length;
    $(`input[name="loecher"]`).val(loecher);

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'calculatePrice',
            'security': ajax_object.security,
            'data': form.serialize()
        },
        success: function (data) {
            if (data.pid) {
                $('#preis').text(Euro.format(data.prodData.gesPreis));
            }
        }
    });
}

export function setAccordeonLabels() {
    $('.form-section.accordion-section').each(function () {
        const accordion = $(this);
        const source = accordion.find('h3').attr('data-source');
        const sourceLabel = accordion.find('h3').attr('data-label');

        const valide = checkFormSectionValidity(accordion);
        const werte = {};
        if (valide) {
            if (accordion.attr('id') != 'auswahl-bohrung') {
                accordion.find('input[type="radio"]:checked,input[type="number"]').each(function () {
                    const name = $(this).attr('name');
                    const id = $(this).attr('id');
                    const label = $(`label[for="${id}"]`).text();

                    if ($(this).attr('type') == 'number' && $(this).val()) {
                        werte[`${name}`] = label + ': ' + $(this).val() + 'mm';
                    } else if ($(this).attr('type') == 'radio') {
                        werte[`${name}`] = label;
                    }
                });

                accordion.find('h3.accordion-header .data').text(Object.values(werte).join(', '));
                accordion.find('h3.accordion-header span[data-status="false"]').text('Ok').attr('data-status', 'ok');
                $(`.zusammenfassung [data-source="${source}"]`).html(`<span class="label">${sourceLabel}:</span> ` + Object.values(werte).join(', '));
            } else {
                let ind = 1;
                $('#bohrungen').find('.b-row').each(function () {
                    const rowWerte = {};
                    $(this).find('input[type="number"]').each(function () {
                        const id = $(this).attr('id');
                        const label = $(`label[for="${id}"]`).text();
                        if ($(this).val()) {
                            rowWerte[`${label}`] = label + ': ' + $(this).val() + 'mm';
                        }
                    });
                    werte[`${ind}`] = Object.values(rowWerte).join(', ');
                    ind++;
                });
                if (Object.values(werte)[0] != '') {
                    const bohrungen = Object.values(werte).map(wert => `<div>${wert}</div>`);
                    $(`.zusammenfassung [data-source="${source}"]`).html(`<div class="label">${sourceLabel}:</div> ` + bohrungen.join(''));
                }
            }
        } else {
            accordion.find('h3.accordion-header .data').text('');
            accordion.find('h3.accordion-header span[data-status]').text('Muss noch konfiguriert werden').attr('data-status', 'false');
            $(`.zusammenfassung [data-source="${source}"]`).html('');
        }
    });
}

export function setCanvas() {
    const store = JSON.parse(localStorage.getItem('konf'));
    const breite = store.breite;
    const hoehe = store.hoehe;

    calculateScaleFactor();

    $('#canvas').get(0).style.setProperty('--mm-width', breite + 'px');
    $('#canvas').get(0).style.setProperty('--mm-height', hoehe + 'px');
    $('.glas-container .mass-bottom').text(`${breite}mm`);
    $('.glas-container .mass-right').text(`${hoehe}mm`);
    $('#canvas').get(0).style.setProperty('--corner-cut', store.eckabschnitt + 'px');
    $('#canvas').get(0).style.setProperty('--border-radius', store.eckrundung + 'px');
}

export function calculateScaleFactor() {
    const store = JSON.parse(localStorage.getItem('konf'));
    const breite = store.breite;
    const hoehe = store.hoehe;
    const canvasW = parseFloat($('#canvas').width()) * 0.8;

    if (breite < hoehe) {
        if (hoehe < canvasW) {
            $('#canvas').get(0).style.setProperty('--scale-factor', (canvasW / hoehe) * 0.85);
        } else {
            $('#canvas').get(0).style.setProperty('--scale-factor', 1 / (hoehe / canvasW));
        }
    } else {
        if (breite < canvasW) {
            $('#canvas').get(0).style.setProperty('--scale-factor', (canvasW / breite) * 0.95);
        } else {
            $('#canvas').get(0).style.setProperty('--scale-factor', 1 / (breite / canvasW));
        }
    }
}

export function setEcken() {
    const store = JSON.parse(localStorage.getItem('konf'));
    const breite = store.breite;
    const hoehe = store.hoehe;

    const maxEcke = Math.max(breite, hoehe) / 2;
    $('#eckabschnitt, #eckrundung').attr('max', maxEcke);
    $('#eckabschnitt, #eckrundung').attr('placeholder', `min. 20, max. ${maxEcke}`);
    $('#eckabschnitt, #eckrundung').siblings('.form-error').find('.max').text(maxEcke);



    if ($('#eckabschnitt').val()) {
        $('#eckabschnitt').trigger('change');
    }
    if ($('#eckrundung').val()) {
        $('#eckrundung').trigger('change');
    }
}

export function toggleShipping() {
    if ($('#alt-shipping').is(':checked')) {
        $('#shipping').slideDown();
        $('#shipping').find('input,select').prop('required', true);
        setRequiredLabels();
    } else {
        $('#shipping').slideUp();
        $('#shipping').find('input,select').prop('required', false);
        setRequiredLabels();
    }
}
export function setRequiredLabels() {
    $('input,select,textarea').each(function () {
        const formElem = $(this);
        const elemId = formElem.attr('id');
        const isRequired = formElem.prop('required');
        if (isRequired) {
            if (!$(`label[for=${elemId}] .req`).length) {
                $(`label[for=${elemId}]`).append('<span class="req">*</span>');
            }
        } else {
            $(`label[for=${elemId}]`).find('span.req').first().remove();
        }
    });
}

export function checkUid(input) {
    const rawVal = input.val();
    const cleanSyntax = /[^A-Z0-9]/gm;
    const subst = ``;
    const val = rawVal.replace(cleanSyntax, subst);

    const lc = val.split('', 2).join('');

    if (lc != 'DE' && lc != 'LU') {
        input.siblings('.form-error.not-complete').show();
        input.siblings('.form-error.not-valid').hide();
        formValidator.toggleInvalidClass(input, false);
    } else {
        input.siblings('.form-error.not-complete').hide();
        input.siblings('.form-error.not-valid').hide();
        const result = formValidator.isUId(input);
        if (result) {
            formValidator.toggleInvalidClass(input, true);
        } else {
            input.siblings('.form-error.not-valid').show();
            formValidator.toggleInvalidClass(input, false);
        }
    }
}

export async function checkPLZ(input) {
    input.siblings('.form-error.not-valid').hide();
    const result = await formValidator.isPLZ(input);

    if (result) {
        formValidator.toggleInvalidClass(input, true);
    } else {
        input.siblings('.form-error.not-valid').show();
        formValidator.toggleInvalidClass(input, false);
    }
}

export function rdtsSetValidation(form) {
    const isFormValid = formValidator.validateForm(form);
    if (!isFormValid) {
        form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
    }
    form.find('input:not([type="submit"]),select,textarea').on('input change', debounce((e) => {
        const isFormValid = formValidator.validateForm(form);
        if (isFormValid) {
            form.find('button[type="submit"]').prop('disabled', false).removeClass('disabled');
        }
    }));
}

export async function rdtsDeleteOrder(uuid) {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'delete_order',
            'security': ajax_object.security,
            'data': uuid
        },
        success: function (data) {
            if (data.bid) {
                return true;
            } else {
                return false;
            }
        }
    });
}